import * as React from 'react';

export type Provider<T> = [React.Context<T>, T];

export const renderWithProviders = (providers: Provider<any>[], children: JSX.Element) => {
  return providers.reduce((result: JSX.Element, [Context, value]) => {
    return <Context.Provider value={value}>{result}</Context.Provider>;
  }, children);
};
